// src/components/Unauthorized/Unauthorized.tsx
import React from "react";
import {
  Box,
  Text,
  Stack,
  Paper,
  ThemeIcon,
  Divider,
} from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import {
  unauthorizedPageErrorMessage,
  unauthorizedPageResolutionMessage,
} from "../../constants/app-constant";

const Unauthorized: React.FC = () => {
  return (
    <Box
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      }}
    >
      <Paper
        shadow='lg'
        radius='md'
        p={48}
        style={{
          maxWidth: 460,
          width: "100%",
          background: "#ffffff",
          border: "1px solid #dee2e6",
        }}
      >
        <Stack align='center' gap='xl'>
          {/* Clean, minimal icon */}
          <ThemeIcon
            size={80}
            radius='xl'
            variant='light'
            color='red'
            style={{
              background: "linear-gradient(135deg, #fa5252 0%, #e03131 100%)",
              color: "white",
              border: "none",
            }}
          >
            <IconLock size={36} stroke={1.8} />
          </ThemeIcon>

          {/* Typography with better hierarchy */}
          <Box style={{ textAlign: "center" }}>
            <Text
              size='xl'
              fw={600}
              style={{
                color: "#212529",
                marginBottom: "8px",
                fontSize: "24px",
                letterSpacing: "-0.5px",
              }}
            >
              Access Restricted
            </Text>
            <Text
              size='md'
              c='dimmed'
              fw={400}
              style={{
                fontSize: "16px",
                color: "#6c757d",
              }}
            >
              Authentication Required
            </Text>
          </Box>

          {/* Clean divider */}
          <Divider size='xs' color='gray.3' style={{ width: "80%" }} />

          {/* Clear, concise messaging */}
          <Box style={{ textAlign: "center", maxWidth: "320px" }}>
            <Text
              size='md'
              style={{
                lineHeight: 1.6,
                marginBottom: "16px",
                fontSize: "15px",
                color: "#495057",
              }}
            >
              {unauthorizedPageErrorMessage}
            </Text>

            <Text size='lg' c='bold' fw={"20px"}>
              {unauthorizedPageResolutionMessage}
            </Text>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
